import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './App.css';
import { CartProvider } from './context/CartContext';
import { Layout } from './components/layout/Layout';
import { HomePage } from './pages/HomePage';
import { OurStoryPage } from './pages/OurStoryPage';
import { HowToMakePage } from './pages/HowToMakePage';
import { WhyChoosePage } from './pages/WhyChoosePage';
import { ContactUsPage } from './pages/ContactUsPage';
import { ReviewsPage } from './pages/ReviewsPage';
import { AdminPage } from './components/admin/AdminPage';
import { TrackOrderPage } from './components/track/TrackOrderPage';

function App() {
  return (
    <CartProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/admin" element={<AdminPage />} />
          <Route path="/track" element={<TrackOrderPage />} />
          <Route element={<Layout />}>
            <Route path="/" element={<HomePage />} />
            <Route path="/our-story" element={<OurStoryPage />} />
            <Route path="/how-to-make" element={<HowToMakePage />} />
            <Route path="/why-choose" element={<WhyChoosePage />} />
            <Route path="/contact-us" element={<ContactUsPage />} />
            <Route path="/reviews" element={<ReviewsPage />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </CartProvider>
  );
}

export default App;
